export interface IColors {
  black: string;
  white: string;
  red: string;
  green: string;
  grey: string;
  lightGrey: string;
}

export const colors: IColors = {
  black: '#000000',
  white: '#ffffff',
  red: '#ff0000',
  green: '#6BC54B',
  grey: '#8F8F8F',
  lightGrey: '#EDEDED',
};
